const accBtn = document.querySelectorAll(".acc__txt");

// URLからハッシュ（アンカー）を取得
const hash = window.location.hash;

function disableScroll(event) {
    event.preventDefault();
}

// if (hash && accBtn) {
//     document.body.style.overflow = "hidden";
//     document.body.style.scrollBehavior = "";

//     window.addEventListener("load", (event) => {
//         setTimeout(() => {
//             const targetElement = document.querySelector(hash);
//             if (targetElement) {
//                 // scroll-margin-topの値を取得
//                 const scrollMarginTop = parseInt(
//                     window.getComputedStyle(targetElement).scrollMarginTop,
//                     10
//                 );

//                 // 要素の位置を計算（scroll-margin-topを考慮）
//                 const elementPosition =
//                     targetElement.getBoundingClientRect().top +
//                     window.pageYOffset -
//                     scrollMarginTop;

//                 // スムーズにスクロール
//                 window.scrollTo({
//                     top: elementPosition,
//                     // behavior: "smooth",
//                 });
//                 setTimeout(() => {
//                     document.body.style.overflow = "";
//                     document.body.style.scrollBehavior = "smooth";
//                 }, 1000);
//             }
//         }, 1000);
//     });
// }

accBtn.forEach((accBtnList) => {
    const ans =
        accBtnList.previousElementSibling !== null
            ? accBtnList.previousElementSibling
            : accBtnList.nextElementSibling;

    let height = ans.getBoundingClientRect().height;
    ans.style.height = "0px";

    if (accBtnList.parentNode.classList.contains("nothing")) {
        return;
    }

    accBtnList.addEventListener("click", () => {
        openAcc();
    });

    // URLからハッシュ（アンカー）を取得
    const hash = window.location.hash;

    if (hash) {
        if (accBtnList.parentNode.id == hash.slice(1)) {
            openAcc();
        }
    }

    if (accBtnList.parentNode.classList.contains("opened")) {
        openAcc();
    }

    function openAcc() {
        const accBtnParent = accBtnList.parentNode;
        accBtnParent.classList.toggle("is-on");

        if (accBtnParent.classList.contains("is-on")) {
            ans.style.height = `${height + 2}px`;
            setTimeout(() => {
                ans.style.height = `auto`;
            }, 400);
        } else {
            ans.style.height = `${height + 2}px`;
            setTimeout(() => {
                ans.style.height = "0vw";
            }, 100);
        }
    }
});
